import { UserLock } from "lucide-react";
import { Container } from '../../common/HtmlTags/Container/Container';
import { Heading } from '../../common/HtmlTags/Heading/Heading';
import { Paragraph } from '../../common/HtmlTags/Paragraph/Paragraph';
import { Button } from "../../common/HtmlTags/Button/Button";
import { useAuth } from "../../../hooks/useAuth";
import { SHARE_LABELS } from "../../../utils/constants";
import './SuspendedAccount.css';

const SuspendedAccount = () => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Container className="suspended-acc-wrapper">
      <Container
        className="suspended-acc-content-section-wrapper"
      >
        <UserLock className="suspended-acc-icon" strokeWidth={1.5} color="var(--primary-shade1)"/>
        <Container className="suspended-acc-content-wrapper">
          <Heading variant="h2">{SHARE_LABELS.SUSPENDED_ACCOUNT_TITLE}</Heading>
          <Paragraph>
            {SHARE_LABELS.SUSPENDED_ACCOUNT_DESCRIPTION}
          </Paragraph>
          <Button
            className="suspended-acc-logout-btn"
            type="button"
            palette="primary"
            size="large"
            colorScheme="dark"
            hasIcon={false}
            onClick={handleLogout}
          >
            {SHARE_LABELS.BACK_TO_LOGIN}
          </Button>
        </Container>
      </Container>
    </Container>
  );
};

export default SuspendedAccount;
